import React, { Component } from "react";

/**
 *  Displaying URL Content in IFRAME
 */
class OrgChart extends Component {
  render() {
    return (
      <div>
        <iframe
          src={this.props.url}
          width="100%"
          height="1000px"
          title="Organization Chart"
        ></iframe>
      </div>
    );
  }
}

export default OrgChart;
